export const asiaGeoURL = {
  type: "Topology",
  arcs: [
    [
      [31921, 8788],
      [-44, -37],
    ],
    [
      [31877, 8751],
      [-56, -34],
      [-57, 12],
      [-134, -14],
      [-118, -64],
      [-57, -77],
      [53, -85],
      [5, -61],
      [-69, -95],
      [-5, -112],
      [-65, -18],
      [-65, 18],
      [36, -128],
      [-93, -44],
      [-40, -116],
      [9, -86],
      [-37, -51],
      [-110, 29],
      [-98, -108],
      [-81, -2],
      [-42, -48],
      [-21, -194],
      [-145, -52],
      [-70, 5],
      [-49, -33],
      [-65, 20],
      [-137, -16],
      [-204, 80],
    ],
    [
      [30162, 7477],
      [120, 176],
      [-18, 95],
      [-101, 18],
      [-3, 136],
      [-33, 161],
      [39, 70],
      [-46, 16],
      [-3, 81],
      [28, 79],
      [44, 50],
      [26, 142],
    ],
    [
      [30215, 8501],
      [169, -70],
      [58, 38],
      [33, 75],
      [115, 52],
      [43, 55],
      [19, 113],
      [93, 26],
      [21, 50],
      [106, -28],
    ],
    [
      [30872, 8812],
      [61, 3],
      [29, -34],
      [68, 0],
    ],
    [
      [31030, 8781],
      [66, -14],
      [88, 34],
      [40, -32],
      [25, 82],
      [79, -8],
      [1, 62],
      [54, 80],
      [47, 24],
      [78, -102],
      [-20, -148],
      [50, -65],
      [181, 135],
      [173, -12],
      [29, -29],
    ],
    [
      [29590, 6725],
      [13, -115],
    ],
    [
      [29603, 6610],
      [-72, -114],
      [24, -46],
      [-58, -55],
      [-43, -138],
      [-1, -52],
    ],
    [
      [29453, 6205],
      [-10, -15],
      [-316, 56],
      [-124, 204],
      [-3, 31],
    ],
    [
      [29000, 6481],
      [30, -45],
      [52, -5],
      [56, 30],
      [148, -14],
      [66, 34],
      [41, 98],
      [47, 37],
      [125, 186],
    ],
    [
      [29565, 6802],
      [25, -77],
    ],
    [
      [28178, 9510],
      [69, -91],
      [-4, -60],
      [57, -39],
      [-15, -74],
      [93, -103],
      [-11, -61],
    ],
    [
      [28367, 9082],
      [-47, -4],
    ],
    [
      [28320, 9078],
      [-46, 88],
      [-125, 62],
    ],
    [
      [28149, 9228],
      [-39, 48],
      [-54, 6],
      [-55, 60],
      [17, 59],
      [-36, 76],
    ],
    [
      [27982, 9477],
      [196, 33],
    ],
    [
      [28320, 9078],
      [-76, 19],
      [-91, 119],
    ],
    [
      [28153, 9216],
      [-4, 12],
    ],
    [
      [28357, 9617],
      [39, -7],
      [66, -98],
      [75, -17],
      [89, 114],
      [58, -77],
      [19, -64],
      [87, -122],
      [-39, -27],
      [-36, -132],
      [-41, -52],
      [-11, -133],
    ],
    [
      [28663, 9002],
      [-34, -7],
      [-74, 76],
      [41, 99],
      [-62, 55],
      [-123, -93],
      [-44, -50],
    ],
    [
      [28178, 9510],
      [31, 27],
      [120, -43],
      [-2, 73],
      [30, 50],
    ],
    [
      [34136, 6076],
      [2, -90],
      [-52, -27],
      [11, -46],
    ],
    [
      [34097, 5913],
      [-27, 17],
      [-39, 223],
      [-24, 52],
      [-53, -31],
      [-44, 44],
      [-46, -2],
      [26, -80],
      [-54, -91],
      [-135, 2],
      [-6, 56],
    ],
    [
      [33695, 6103],
      [-27, 148],
      [-38, 122],
      [25, 114],
      [-90, 63],
      [52, 94],
      [58, -1],
      [-103, 132],
      [11, 41],
      [62, 49],
      [19, -32],
      [128, -58],
      [-5, -95],
      [72, -40],
      [213, 4],
      [21, -70],
      [-16, -66],
      [-93, -55],
      [-28, -86],
      [20, -84],
      [29, -28],
      [77, 133],
      [26, -79],
      [28, -233],
    ],
    [
      [36962, 3041],
      [-14, -16],
    ],
    [
      [36948, 3025],
      [14, 16],
    ],
    [
      [36818, 2986],
      [124, 52],
    ],
    [
      [36942, 3038],
      [-29, -27],
      [10, -68],
      [-31, -60],
      [-43, 82],
      [-31, 21],
    ],
    [
      [34018, 7104],
      [42, -51],
      [8, -110],
      [-181, -13],
      [-26, 20],
      [-71, -35],
      [-108, 38],
      [-8, 72],
    ],
    [
      [33674, 7025],
      [69, 127],
      [53, 47],
      [50, 7],
      [172, -102],
    ],
    [
      [36444, 5668],
      [-39, -47],
      [-34, -131],
      [-85, -51],
      [-73, -19],
      [-59, 39],
      [-8, 139],
      [66, 64],
      [18, 48],
      [107, 26],
      [98, -12],
      [9, -56],
    ],
    [
      [38889, 9730],
      [-37, 67],
      [-45, 16],
      [-19, -92],
      [-60, -18],
      [-35, -51],
      [-117, -17],
      [19, -105],
      [-126, 20],
      [-36, 48],
      [-111, -158],
      [-139, -74],
      [-66, -68],
    ],
    [
      [38117, 9298],
      [-48, -51],
      [-45, 11],
      [-154, -82],
      [-67, -83],
      [-53, 100],
      [108, 177],
      [-31, 43],
      [-87, 35],
      [-46, -20],
      [-69, -113],
      [-113, -54],
      [-29, -81],
      [-46, -53],
      [-74, -19],
      [-79, 11],
      [-19, -85],
      [65, -84],
      [95, 2],
      [50, -68],
      [-34, -87],
      [59, -28],
      [128, 111],
      [58, 13],
      [29, -42],
      [163, -30],
      [8, -84],
      [-62, 8],
      [-109, -57],
      [-189, -193],
      [-55, -93],
      [54, -90],
      [77, -43],
      [19, -80],
      [61, -151],
      [2, -68],
      [56, -38],
      [11, -54],
      [-47, -69],
      [82, -79],
      [32, -65],
      [-126, -66],
      [126, -128],
      [-1, -66],
      [-58, -141],
      [-84, -125],
      [-40, -134],
      [-79, -92],
      [-27, -72],
      [-21, -143],
      [-28, 17],
      [-71, -129],
      [-8, -49],
      [-76, 1],
      [-19, -97],
      [-102, -83],
      [-98, -107],
      [-115, -48],
      [-83, 18],
      [-61, -42],
    ],
    [
      [36847, 6179],
      [-18, -5],
    ],
    [
      [36829, 6174],
      [-62, -52],
      [-95, -48],
      [-28, -34],
      [-77, -2],
      [-45, -42],
      [-53, 1],
      [-132, -97],
      [48, -91],
      [-51, -41],
      [-37, 46],
      [-38, 176],
      [-117, 44],
      [-76, -45],
    ],
    [
      [36066, 5989],
      [-80, 20],
      [-79, 72],
      [-24, 75],
      [17, 78],
      [-104, 9],
      [-63, 71],
      [-67, -41],
      [-12, -48],
      [-45, -23],
      [-129, 18],
      [-40, -62],
      [-69, 58],
      [-40, -65],
    ],
    [
      [35331, 6151],
      [-58, 8],
      [-18, -38],
      [36, -108],
      [-12, -87],
      [-62, 20],
      [-7, 54],
    ],
    [
      [35210, 6000],
      [-67, -14],
      [-84, 44],
      [-1, 58],
      [-97, 28],
      [18, 92],
      [28, 41],
      [-85, 41],
      [-10, 105],
      [-34, 62],
      [-77, -17],
      [-23, 18],
      [-21, 110],
      [25, 61],
      [120, 141],
      [7, 158],
      [-11, 147],
      [-70, 67],
      [2, 30],
      [-74, 69],
      [-26, -55],
    ],
    [
      [34730, 7186],
      [-45, 20],
      [-103, 184],
      [-79, -42],
      [-92, 6],
      [-166, -88],
      [-100, -100],
      [-3, -34],
      [-82, -34],
      [-42, 6],
    ],
    [
      [33674, 7025],
      [-5, 94],
      [-30, 47],
      [-62, -44],
    ],
    [
      [33577, 7122],
      [-120, -6],
      [-62, 50],
      [-28, -35],
      [-57, -5],
      [-17, 49],
      [-96, 29],
      [-106, 103],
      [-17, 62],
      [-73, -10],
      [-44, 77],
      [-41, 6],
      [-156, 134],
      [-50, -73],
      [-25, 34],
    ],
    [
      [32685, 7537],
      [-93, 66],
      [-52, 70],
      [-38, -1],
      [-42, 66],
      [-57, 2],
      [0, 112],
      [25, 68],
      [70, 71],
      [-15, 67],
      [-75, 76],
      [-6, 94],
      [32, 37],
      [-90, 66],
      [-59, 149],
    ],
    [
      [32285, 8480],
      [-48, -5],
      [-80, 31],
    ],
    [
      [32157, 8506],
      [-76, 29],
      [-35, 52],
      [11, 64],
      [-79, 81],
      [-101, 19],
    ],
    [
      [31921, 8788],
      [34, 30],
      [-47, 121],
      [-1, 77],
      [-56, 27],
      [-67, -11],
      [-21, 150],
    ],
    [
      [31763, 9182],
      [47, 109],
      [46, 8],
      [58, 72],
      [106, -39],
      [96, 22],
      [52, 107],
      [152, 4],
      [35, 60],
      [119, 73],
      [55, 17],
      [58, 55],
    ],
    [
      [32587, 9670],
      [-9, 77],
      [29, 72],
      [51, 15],
      [-54, 176],
      [4, 101],
      [-40, 62],
      [210, 57],
      [70, 34],
      [68, 214],
      [39, 85],
      [95, -42],
      [126, -22],
      [73, 35],
      [22, 60],
      [-20, 95],
      [34, 86],
      [98, 22],
      [34, 100],
      [61, -1],
    ],
    [
      [33478, 10896],
      [62, 14],
    ],
    [
      [33540, 10910],
      [25, -111],
      [128, -97],
      [63, 6],
      [112, -95],
      [76, -165],
      [-5, -97],
      [-44, -94],
      [31, -54],
      [95, -23],
      [234, -19],
      [146, -108],
      [86, -10],
      [66, -191],
      [55, -84],
      [106, 8],
      [286, -40],
      [67, 20],
      [203, -28],
      [50, -59],
      [130, -32],
      [81, -44],
      [98, 20],
      [64, -49],
      [107, 71],
      [113, 52],
      [176, 30],
      [164, -1],
      [116, 57],
      [66, 92],
      [125, 73],
      [-67, 123],
      [42, 103],
      [81, 18],
      [26, -26],
      [127, -33],
      [57, 36],
      [59, 79],
      [139, 11],
      [47, 41],
      [74, 112],
      [87, 8],
      [12, 39],
      [178, 33],
      [110, -29],
      [26, 44],
      [-26, 57],
      [-153, 147],
      [-92, -2],
      [-53, -58],
      [-58, 39],
      [-125, -29],
      [-43, 74],
      [147, 302],
    ],
    [
      [37155, 11027],
      [134, -55],
      [115, 80],
      [80, 23],
      [-2, 90],
      [102, 190],
      [84, 80],
      [-63, 133],
      [74, 74],
      [184, 37],
      [163, 11],
      [135, -72],
      [51, 11],
      [89, -54],
      [87, -134],
      [-11, -30],
      [142, -313],
      [-5, -77],
      [69, -44],
      [72, 12],
      [93, -32],
      [141, -141],
      [16, -92],
      [45, -78],
      [189, 5],
      [82, 74],
      [151, 46],
      [48, -119],
      [-77, -81],
      [-32, -178],
      [-119, -219],
      [-142, 55],
      [-94, -116],
      [25, -112],
      [2, -119],
      [-36, -95],
      [-58, -57],
    ],
    [
      [26801, 8403],
      [2, -1],
    ],
    [
      [26803, 8402],
      [-16, 0],
    ],
    [
      [26787, 8402],
      [1, 2],
    ],
    [
      [26788, 8404],
      [13, -1],
    ],
    [
      [26623, 8422],
      [2, 1],
    ],
    [
      [26625, 8423],
      [5, 2],
    ],
    [
      [26630, 8425],
      [2, 0],
    ],
    [
      [26632, 8425],
      [-9, -3],
    ],
    [
      [26760, 8397],
      [3, -8],
    ],
    [
      [26763, 8389],
      [-36, 31],
      [-62, -16],
      [-29, 20],
    ],
    [
      [26636, 8424],
      [3, 0],
    ],
    [
      [26639, 8424],
      [86, 3],
      [35, -30],
    ],
    [
      [26625, 8423],
      [5, 2],
    ],
    [
      [26788, 8404],
      [-28, -7],
    ],
    [
      [26639, 8424],
      [26, 38],
      [63, -12],
      [76, 25],
      [-3, -72],
    ],
    [
      [26803, 8402],
      [-17, -18],
    ],
    [
      [26786, 8384],
      [1, 18],
    ],
    [
      [26763, 8389],
      [0, -2],
    ],
    [
      [26763, 8387],
      [-86, -61],
    ],
    [
      [26677, 8326],
      [-32, 4],
    ],
    [
      [26645, 8330],
      [-44, 18],
      [22, 74],
    ],
    [
      [26632, 8425],
      [4, -1],
    ],
    [
      [26786, 8384],
      [-13, 3],
    ],
    [
      [26773, 8387],
      [-10, 0],
    ],
    [
      [26831, 7718],
      [29, 66],
    ],
    [
      [26860, 7784],
      [-29, -66],
    ],
    [
      [27875, 9561],
      [-18, -26],
      [-115, 15],
    ],
    [
      [27742, 9550],
      [31, 69],
    ],
    [
      [27773, 9619],
      [80, -12],
      [22, -46],
    ],
    [
      [27982, 9477],
      [-107, 84],
    ],
    [
      [27773, 9619],
      [-34, 131],
      [-80, 75],
      [-66, 14],
      [40, 71],
      [113, -56],
      [150, -9],
      [131, -76],
      [133, 2],
      [62, -42],
      [74, -89],
      [61, -23],
    ],
    [
      [36847, 6179],
      [-18, -5],
    ],
    [
      [37571, 504],
      [98, -107],
      [-10, -44],
      [-70, -2],
      [-22, 41],
      [-62, 43],
      [-56, 13],
      [17, 51],
      [105, 5],
    ],
    [
      [38204, 482],
      [-81, -121],
      [-74, -36],
      [-39, 6],
      [22, 128],
      [43, 48],
    ],
    [
      [38075, 507],
      [52, 29],
    ],
    [
      [38127, 536],
      [59, 39],
    ],
    [
      [38186, 575],
      [18, -93],
    ],
    [
      [37162, 676],
      [-30, -73],
      [-63, -17],
      [4, 81],
      [43, 43],
      [46, -34],
    ],
    [
      [38142, 722],
      [66, -5],
      [4, -34],
      [-89, -20],
      [19, 59],
    ],
    [
      [37316, 728],
      [127, -37],
      [-11, -68],
      [-75, -12],
      [-161, -62],
      [-31, 16],
      [3, 77],
      [51, 40],
      [101, -20],
      [-4, 66],
    ],
    [
      [37944, 717],
      [-22, -80],
      [-127, -48],
      [-109, -8],
      [-42, 23],
      [-77, -3],
      [-19, 48],
      [57, 49],
      [87, -12],
      [67, -47],
      [41, 23],
      [57, -29],
      [87, 84],
    ],
    [
      [37007, 715],
      [26, -36],
      [-57, -60],
      [-41, 44],
      [-9, 48],
      [45, 24],
      [36, -20],
    ],
    [
      [39936, 738],
      [-56, -60],
      [-101, -1],
      [49, 138],
      [97, 42],
      [30, -33],
      [-19, -86],
    ],
    [
      [39029, 894],
      [-1, -77],
      [-35, -62],
      [-34, 18],
      [20, 67],
      [50, 54],
    ],
    [
      [36817, 945],
      [-19, -45],
      [-45, -16],
      [-92, 11],
      [22, 48],
      [134, 2],
    ],
    [
      [35837, 1100],
      [257, -41],
      [41, -44],
      [8, -49],
      [116, -13],
      [103, -25],
      [47, 92],
      [54, -42],
      [42, 13],
      [72, -48],
      [64, -18],
      [22, -96],
      [68, -46],
      [90, 31],
      [56, -38],
      [-14, -105],
      [-20, -40],
      [-125, 66],
      [-66, -31],
      [-110, 34],
      [-15, -20],
      [-150, 46],
      [-55, 40],
      [-83, 31],
      [-104, 4],
      [-27, -23],
      [-115, 57],
      [-111, 16],
      [-30, 76],
      [-40, 29],
      [-17, 68],
      [8, 65],
      [34, 11],
    ],
    [
      [39396, 1204],
      [24, -119],
      [-21, -49],
      [-41, 51],
      [38, 117],
    ],
    [
      [37918, 1288],
      [-29, -85],
      [-34, 10],
      [16, 113],
      [47, -38],
    ],
    [
      [38431, 1615],
      [48, -46],
      [-2, -42],
      [-63, -45],
      [-71, 46],
      [-21, 43],
      [52, 51],
      [57, -7],
    ],
    [
      [38765, 1674],
      [130, -61],
      [37, -80],
      [-7, -53],
      [-160, 102],
      [-7, -30],
      [-76, 47],
      [-50, -46],
      [-38, 107],
      [118, -18],
      [53, 32],
    ],
    [
      [36048, 1715],
      [53, -37],
      [-10, -68],
      [-55, -10],
      [-21, 33],
      [33, 82],
    ],
    [
      [35801, 1903],
      [38, -69],
      [11, -84],
      [52, -32],
      [-8, -73],
      [-79, 22],
      [-24, 115],
      [-61, 7],
      [19, 101],
      [52, 13],
    ],
    [
      [34930, 2001],
      [44, -118],
      [-48, -13],
      [-37, 85],
      [41, 46],
    ],
    [
      [39128, 2107],
      [89, -33],
      [30, -34],
      [73, 0],
      [39, -112],
      [-25, -59],
      [10, -113],
      [103, -180],
      [60, -6],
      [100, 143],
      [17, 61],
      [45, -6],
      [58, 31],
      [-10, 52],
      [81, 53],
      [110, -54],
      [17, -23],
      [133, -81],
      [30, 10],
      [109, -50],
      [0, -355],
      [0, -409],
      [0, -393],
      [-131, 178],
      [-72, -17],
      [-65, 11],
      [20, 49],
      [12, 54],
      [-51, 65],
      [17, 69],
      [-44, 72],
      [-46, 155],
      [-96, 89],
      [-64, 18],
      [-107, 73],
      [-98, 12],
      [-95, 96],
      [-30, -6],
      [-43, 54],
      [-36, 8],
      [-36, -81],
      [-60, 22],
      [5, 83],
      [-89, 136],
      [77, -20],
      [37, 58],
      [88, -6],
      [16, 53],
      [-71, 2],
      [-75, -18],
      [-78, 36],
      [-22, 90],
      [-87, 13],
      [5, 126],
      [80, 24],
      [70, 60],
    ],
    [
      [38926, 2168],
      [59, -28],
      [-8, -41],
      [-61, 18],
      [10, 51],
    ],
    [
      [34737, 2438],
      [70, -94],
      [-7, -61],
      [-62, 55],
      [-19, 57],
      [18, 43],
    ],
    [
      [38204, 2466],
      [10, -45],
      [-30, -80],
      [-58, -92],
      [-87, -25],
      [-63, 2],
      [-33, 28],
      [-156, 3],
      [-105, -13],
      [-65, 9],
      [-48, -122],
      [12, -80],
      [62, -79],
      [12, -52],
      [49, -4],
      [54, 99],
      [76, -11],
      [12, 28],
      [89, 1],
      [41, 34],
      [18, -77],
      [-72, 14],
      [-55, -101],
      [-72, -40],
      [-13, -34],
      [40, -140],
      [47, -78],
      [-23, -75],
      [57, -59],
      [-7, -90],
      [-62, -22],
      [-15, -60],
      [-63, 35],
      [6, 76],
      [-80, 123],
      [22, 61],
      [0, 79],
      [-37, 24],
      [-68, -59],
      [24, -57],
      [-9, -118],
      [6, -114],
      [-17, -102],
      [7, -64],
      [-97, -22],
      [-23, 42],
      [33, 192],
      [-5, 61],
      [-36, 97],
      [-46, -25],
      [-22, 141],
      [48, 59],
      [27, 90],
      [-3, 128],
      [44, 85],
      [13, 174],
      [35, 89],
      [63, 7],
      [50, 101],
      [83, -51],
      [103, -7],
      [187, -33],
      [43, 32],
      [33, 61],
      [64, 56],
    ],
    [
      [38579, 2558],
      [-26, -65],
      [44, -78],
      [65, 33],
      [-2, -89],
      [-49, -30],
      [0, -42],
      [-93, -44],
      [-21, 144],
      [22, 93],
      [60, 78],
    ],
    [
      [38646, 2632],
      [-3, -89],
      [-46, 28],
      [49, 61],
    ],
    [
      [37282, 2909],
      [26, -2],
    ],
    [
      [37308, 2907],
      [-26, 2],
    ],
    [
      [37265, 2908],
      [23, -93],
      [-66, 2],
      [16, -83],
      [94, -161],
      [-22, -81],
      [104, -105],
      [1, -75],
      [-119, 1],
      [-37, -95],
      [-10, -97],
      [13, -76],
      [-34, -24],
      [-118, -156],
      [17, -36],
      [-16, -181],
      [-46, -121],
      [-163, -103],
      [-7, 89],
      [-63, 60],
      [-49, -22],
      [-12, 51],
      [-55, 19],
      [-70, -61],
      [-40, 19],
      [-60, -41],
      [1, 86],
      [-67, 22],
      [-49, -26],
      [-50, 37],
      [-30, -23],
      [-24, 192],
      [-1, 88],
      [-44, 86],
      [-55, 16],
      [-19, 63],
      [5, 109],
      [-30, 41],
      [-9, 87],
      [30, 130],
      [31, 66],
      [38, 27],
    ],
    [
      [36273, 2539],
      [4, -91],
      [110, -128],
      [81, 39],
      [78, -11],
      [45, 78],
      [36, 21],
      [69, -5],
      [79, -54],
      [32, 37],
      [74, -1],
      [42, 83],
      [-10, 44],
      [47, 58],
      [-8, 62],
      [50, 36],
      [23, 203],
      [60, 37],
      [130, -8],
      [50, -31],
    ],
    [
      [34502, 3165],
      [78, -58],
      [66, -11],
      [106, 6],
      [97, -147],
      [4, -61],
      [181, -160],
      [57, -84],
      [38, -91],
      [50, 18],
      [49, -45],
      [10, -48],
      [93, -69],
      [15, -72],
      [39, -44],
      [41, -2],
      [24, -50],
      [36, 17],
      [44, -40],
      [10, -58],
      [-37, -19],
      [-15, -108],
      [58, -54],
      [67, 0],
      [10, -89],
      [54, -134],
      [93, -21],
      [55, -154],
      [-31, -72],
      [11, -141],
      [-15, -242],
      [-60, 64],
      [-24, -56],
      [-62, 52],
      [-40, -27],
      [-49, 89],
      [-124, 115],
      [-76, 90],
      [-11, 62],
      [-74, 69],
      [-66, 118],
      [-28, 98],
      [-60, 137],
      [-13, 80],
      [-61, 93],
      [-25, 70],
      [-59, 31],
      [-7, 62],
      [-69, 234],
      [-110, 84],
      [-7, 81],
      [-105, 157],
      [-42, 13],
      [-125, 179],
      [-29, 127],
      [38, 11],
    ],
    [
      [32685, 7537],
      [-78, -78],
      [-11, -87],
      [-31, -76],
      [139, -83],
      [20, -44],
      [94, -39],
      [87, -73],
      [136, -11],
      [31, 14],
      [62, -32],
      [28, -57],
      [61, -49],
      [39, 21],
      [28, -50],
      [58, 7],
      [53, -35],
      [110, -7],
      [61, 14],
      [12, 51],
      [-25, 66],
      [18, 133],
    ],
    [
      [34730, 7186],
      [-12, -57],
      [-59, -99],
      [-77, -15],
      [-94, -101],
      [-34, -15],
      [3, -102],
      [-67, -113],
      [13, -66],
      [-89, -197],
      [-68, 7],
      [-10, -147],
      [-37, -64],
      [7, -104],
      [-70, -37],
    ],
    [
      [33695, 6103],
      [-37, -102],
      [-99, 50],
      [-97, -51],
      [-44, -83],
      [20, -76],
      [-92, -133],
      [-90, -39],
      [-85, -83],
      [-100, -169],
      [-58, -40],
      [-47, -81],
      [-117, -100],
      [1, -80],
      [-69, -45],
      [-55, 8],
      [-40, -93],
      [-39, 10],
      [-51, -36],
      [-28, -122],
      [17, -80],
      [5, -129],
      [-14, -60],
      [26, -54],
      [-22, -129],
      [-37, -80],
      [-13, -79],
      [13, -74],
      [1, -139],
      [-59, -10],
      [-52, -117],
      [-3, -70],
      [-63, -28],
      [-34, -45],
      [-15, -87],
      [-69, -53],
      [-65, 52],
      [-56, 97],
      [-29, 103],
      [-12, 95],
      [-48, 191],
      [-38, 105],
      [-50, 92],
      [-39, 116],
      [-26, 173],
      [-44, 154],
      [-21, 17],
      [-26, 114],
      [-55, 112],
      [-27, 220],
      [-31, 138],
      [-34, 296],
      [4, 95],
      [25, 85],
      [-43, 93],
      [-6, 178],
      [-51, -63],
      [19, -49],
      [-24, -79],
      [-141, -88],
      [-55, 17],
      [-60, 61],
      [-140, 203],
      [84, 11],
      [71, 37],
      [-118, 50],
      [-86, 74],
      [-46, 104],
    ],
    [
      [31081, 6408],
      [68, 21],
      [0, 58],
      [105, -2],
      [51, -20],
      [137, 92],
      [-53, 133],
      [-73, 98],
      [12, 98],
      [-87, 49],
      [14, 68],
      [96, 146],
      [61, -55],
      [129, 44],
      [66, 148],
      [65, 43],
      [58, 161],
      [72, 46],
      [-11, 33],
      [60, 93],
      [35, 97],
      [-15, 48],
      [42, 56],
      [58, 22],
      [-34, 56],
      [-127, 126],
      [17, 67],
      [-18, 115],
      [-28, 31],
      [64, 70],
      [187, -47],
      [97, 40],
      [62, 68],
    ],
    [
      [32191, 8411],
      [94, 69],
    ],
    [
      [28148, 8772],
      [73, -187],
      [58, -50],
      [44, -110],
      [-46, -51],
    ],
    [
      [28277, 8374],
      [-43, -41],
      [-99, 66],
      [18, 76],
      [-22, 74],
      [-108, -30],
      [-52, 50],
      [84, 109],
      [-49, 39],
      [-129, -6],
      [-28, 47],
    ],
    [
      [27849, 8758],
      [-2, 9],
    ],
    [
      [27847, 8767],
      [51, 47],
      [89, -24],
      [93, 2],
      [68, -20],
    ],
    [
      [28663, 9002],
      [17, -123],
      [54, -44],
      [88, -16],
      [42, -66],
      [76, -53],
      [103, -27],
      [198, 54],
      [65, -12],
      [-12, 93],
    ],
    [
      [29294, 8808],
      [109, 31],
      [9, 43],
      [71, 56],
      [110, 1],
      [17, 31],
      [75, -12],
      [39, -39],
      [189, -53],
      [62, -31],
      [20, -54],
      [63, -29],
      [41, -69],
      [92, 1],
      [24, -183],
    ],
    [
      [30162, 7477],
      [54, -80],
      [47, -116],
      [89, -60],
      [47, -75],
      [8, -137],
      [56, -1],
      [-14, -106],
      [-48, 4],
      [-112, -72],
      [-25, -84],
      [-9, -101],
    ],
    [
      [30255, 6649],
      [-22, -25],
      [-132, 48],
      [-194, 42],
      [-80, -4],
      [-26, 27],
      [-80, 15],
      [-20, 56],
      [-24, 155],
      [-78, 42],
      [-83, -35],
      [-111, -90],
      [-62, 38],
      [-74, -1],
      [-38, 51],
      [-102, 64],
      [-22, 52],
      [-130, 61],
      [-41, 133],
      [-52, 72],
      [2, 55],
      [-64, 86],
      [-152, 26],
      [-50, -21],
    ],
    [
      [28620, 7496],
      [-65, 89],
      [0, 91],
      [-43, 3],
      [20, 137],
      [-54, 102],
      [-128, 106],
      [-62, 124],
      [-58, 65],
      [0, 80],
      [47, 81],
    ],
    [
      [28148, 8772],
      [-21, 102],
      [-49, 33],
      [9, 168],
      [-27, 99],
      [93, 42],
    ],
    [
      [28620, 7496],
      [-73, 5],
    ],
    [
      [28547, 7501],
      [-74, 18],
      [-31, -24],
      [-32, -91],
      [-41, -62],
    ],
    [
      [28369, 7342],
      [-22, -6],
      [-208, 25],
      [-230, 229],
      [-98, 104],
      [-207, 150],
      [-160, 35],
    ],
    [
      [27444, 7879],
      [-46, 223],
    ],
    [
      [27398, 8102],
      [240, 171],
      [63, 77],
      [21, 158],
      [-15, 69],
      [22, 86],
      [53, 16],
      [67, 79],
    ],
    [
      [27020, 7990],
      [-25, -64],
    ],
    [
      [26995, 7926],
      [-44, 29],
      [-33, -65],
      [65, -122],
    ],
    [
      [26983, 7768],
      [-3, -69],
      [-37, -120],
      [-23, -155],
    ],
    [
      [26920, 7424],
      [-17, 33],
      [-72, 261],
    ],
    [
      [26860, 7784],
      [45, 124],
      [33, 144],
    ],
    [
      [26938, 8052],
      [47, -1],
      [43, 57],
    ],
    [
      [27028, 8108],
      [-8, -118],
    ],
    [
      [27444, 7879],
      [-23, -22],
      [-250, -89],
      [127, -177],
      [-63, -89],
      [-90, -23],
      [-35, -66],
      [-58, -55],
      [-133, 29],
    ],
    [
      [26919, 7387],
      [1, 37],
    ],
    [
      [26983, 7768],
      [12, 158],
    ],
    [
      [27020, 7990],
      [2, 1],
    ],
    [
      [27022, 7991],
      [75, -64],
      [56, -13],
      [245, 188],
    ],
    [
      [39251, 8293],
      [-33, -27],
      [-117, -10],
      [-119, -55],
      [-52, 33],
      [27, 55],
      [42, 0],
      [56, 52],
      [97, 129],
      [59, 28],
      [39, -25],
      [189, 32],
      [38, 24],
      [62, -50],
      [29, 86],
      [101, 159],
      [31, -6],
      [111, 39],
      [82, 57],
      [39, 80],
      [72, 61],
      [77, 237],
      [-29, 82],
      [26, 70],
      [-21, 45],
      [114, 104],
      [63, 28],
      [21, -121],
      [38, -51],
      [41, -150],
      [-20, -77],
      [-34, -22],
      [-21, -98],
      [-49, -13],
      [-19, -55],
      [14, -120],
      [-60, -194],
      [35, -97],
      [-45, -31],
      [-11, -66],
      [-66, -32],
      [-43, 51],
      [-47, -12],
      [-1, -65],
      [-50, -25],
      [-165, -11],
      [-64, 20],
      [-43, -32],
      [35, -52],
      [-69, -27],
      [-67, -120],
      [-87, 72],
      [5, 77],
      [-45, 80],
      [-166, -57],
    ],
    [
      [40797, 9883],
      [-31, -38],
      [-97, -45],
      [-53, 14],
      [-86, -60],
      [-48, -128],
      [-191, 120],
      [-89, -54],
      [-101, -162],
      [-28, 28],
      [20, 75],
      [-45, 47],
      [11, 74],
      [48, 17],
      [69, 77],
      [79, 30],
      [-13, 63],
      [38, 40],
      [19, 117],
      [-26, 101],
      [47, 61],
      [128, -164],
      [100, -86],
      [55, 2],
      [107, -60],
      [31, -89],
      [56, 20],
    ],
    [
      [39410, 8183],
      [-53, -57],
      [-66, 5],
      [-59, -33],
      [-45, -102],
      [-55, 28],
      [-11, 95],
      [48, 94],
      [93, -6],
      [15, 42],
      [65, 33],
      [60, -37],
      [8, -62],
    ],
    [
      [39030, 7943],
      [-39, -193],
      [-141, -26],
      [-6, 97],
      [59, 145],
      [-28, 85],
      [-74, -68],
      [-31, 119],
      [101, 41],
      [37, 59],
      [48, -50],
      [83, -13],
      [-2, -55],
      [39, -59],
      [-46, -82],
    ],
    [
      [30480, 10270],
      [-73, 66],
      [32, 68],
      [48, 12],
      [60, -44],
      [0, -57],
      [-67, -45],
    ],
    [
      [32191, 8411],
      [-34, 95],
    ],
    [
      [32587, 9670],
      [-92, 47],
      [-56, 54],
      [-67, 21],
      [-341, 9],
      [-74, -14],
      [-115, 65],
      [-79, -27],
      [-28, -84],
      [-195, 43],
      [-106, -48],
      [-7, -56],
    ],
    [
      [31427, 9680],
      [-79, -38],
      [-56, -59],
      [-103, -57],
      [-73, -142],
      [-58, 43],
      [-8, 67],
      [-156, 0],
      [-23, 141],
      [-61, 1],
      [10, 176],
      [-38, -20],
      [-35, 75],
      [-70, 71],
      [-67, -27],
      [-152, 15],
      [-148, -27],
      [-109, 123],
      [-15, 38],
      [-314, 209],
      [-320, -100],
      [0, -409],
      [0, -244],
    ],
    [
      [29552, 9516],
      [-68, -6],
      [-66, 114],
      [-89, 69],
      [-152, -34],
      [-68, -68],
    ],
    [
      [29109, 9591],
      [-5, 62],
      [43, 100],
      [-101, 32],
      [-77, 108],
      [-128, 215],
      [84, 34],
      [54, 87],
      [146, 12],
      [65, 110],
      [13, 124],
      [-34, 43],
      [-85, -27],
      [-132, 55],
      [-245, -140],
      [-88, 192],
      [-60, 64],
      [-125, 36],
      [4, 54],
      [-75, 24],
      [34, 90],
      [18, 161],
      [91, 110],
      [99, -112],
      [59, 37],
      [-7, 103],
      [187, 125],
      [33, 59],
      [90, -29],
      [129, 52],
      [41, -53],
    ],
    [
      [29137, 11319],
      [119, -14],
      [67, -70],
      [62, 6],
      [127, -88],
      [107, 95],
      [158, 10],
      [103, -17],
      [41, -62],
      [107, -26],
      [31, 57],
      [87, -35],
      [82, 23],
      [13, 114],
      [-120, 34],
      [-48, 48],
      [113, 80],
      [-43, 71],
      [62, 49],
      [-23, 111],
      [23, 68],
      [237, 12],
      [187, 53],
      [80, -7],
      [33, 51],
      [63, -3],
      [274, 61],
      [69, 70],
      [119, -3],
      [66, -36],
      [59, 32],
      [64, -104],
      [0, -111],
      [111, 21],
      [178, -61],
      [-12, -63],
      [103, 13],
      [102, 38],
      [77, 51],
      [146, 56],
      [-35, -80],
      [168, -123],
      [200, -316],
      [65, -125],
      [57, 30],
      [30, 61],
      [174, -104],
      [171, 49],
      [48, -22],
      [53, -105],
      [92, -36],
      [36, -88],
      [195, -13],
      [63, -75],
    ],
    [
      [31763, 9182],
      [-165, -21],
      [-107, 51],
      [-56, -37],
      [-49, 28],
      [-167, -4],
      [3, 79],
      [82, 40],
      [83, -39],
      [41, 44],
    ],
    [
      [31428, 9323],
      [90, -16],
      [87, 42],
      [31, 88],
      [-108, 101],
      [-60, -60],
      [-138, 83],
      [82, 64],
      [15, 55],
    ],
    [
      [35623, 4021],
      [-75, 30],
      [-24, 78],
      [-69, -10],
      [-3, 82],
      [-22, 38],
    ],
    [
      [35430, 4239],
      [-73, 290],
      [95, 181],
      [58, 23],
      [40, -14],
      [113, 17],
      [52, -17],
    ],
    [
      [35715, 4719],
      [86, -73],
      [12, 71],
      [71, 33],
      [51, -35],
      [72, 68],
    ],
    [
      [36007, 4783],
      [-25, -104],
      [35, -104],
      [-17, -91],
      [6, -121],
      [-45, -12],
      [-108, -107],
      [-54, -2],
      [-2, -64],
      [28, -37],
      [-125, -62],
      [-77, -58],
    ],
    [
      [38621, 9028],
      [-43, -58],
      [-110, 0],
      [-61, -84],
    ],
    [
      [38407, 8886],
      [-2, 8],
    ],
    [
      [38405, 8894],
      [61, 86],
      [111, -1],
      [41, 57],
    ],
    [
      [38618, 9036],
      [3, -8],
    ],
    [
      [38405, 8894],
      [-6, -7],
    ],
    [
      [38399, 8887],
      [0, 33],
      [66, 69],
      [111, -1],
      [41, 57],
    ],
    [
      [38617, 9045],
      [1, -9],
    ],
    [
      [38621, 9028],
      [30, -77],
      [88, -154],
      [17, -90],
      [-11, -102],
      [20, -24],
      [-11, -98],
      [-33, -64],
      [-83, -9],
      [-127, -39],
      [-25, -78],
      [-38, 30],
      [-48, -40],
      [-45, 45],
      [12, 111],
      [46, 110],
      [-50, 167],
      [48, 30],
      [-4, 140],
    ],
    [
      [28607, 7243],
      [-95, -1],
      [-30, 82],
      [-113, 18],
    ],
    [
      [28547, 7501],
      [2, -74],
      [58, -184],
    ],
    [
      [35331, 6151],
      [59, -89],
      [45, -29],
      [-9, -89],
      [29, -65],
      [69, -38],
      [49, 54],
      [68, -53],
      [39, -86],
      [-13, -69],
      [-72, -15],
      [-47, -69],
      [109, -93],
      [49, -17],
      [5, -67],
      [40, -35],
      [33, -82],
      [84, -119],
      [31, -93],
      [58, -39],
      [34, -56],
      [-29, -32],
      [63, -87],
      [-18, -100],
    ],
    [
      [35715, 4719],
      [27, 14],
      [23, 98],
      [8, 117],
      [-31, 68],
      [-41, 16],
      [-40, 75],
      [8, 150],
      [-42, 48],
      [-61, 120],
      [-77, 22],
      [-43, -80],
      [-44, -21],
      [-77, 60],
      [-118, -133],
      [-29, 18],
      [33, 87],
      [-17, 67],
      [27, 44],
      [-6, 138],
      [-40, 29],
      [-52, -14],
      [10, 94],
      [-55, 45],
    ],
    [
      [35078, 5781],
      [14, 67],
      [38, 20],
      [26, 90],
      [54, 42],
    ],
    [
      [27034, 8113],
      [-6, -5],
    ],
    [
      [26938, 8052],
      [66, 197],
      [43, 80],
    ],
    [
      [27047, 8329],
      [44, 6],
      [35, -86],
      [-69, -68],
      [-23, -68],
    ],
    [
      [32619, 3872],
      [35, -40],
      [78, -156],
      [10, -63],
      [54, -142],
      [1, -55],
      [-26, -99],
      [-40, -42],
      [-96, -53],
      [-51, 20],
      [-40, 137],
      [-13, 210],
      [36, 249],
      [52, 34],
    ],
    [
      [35078, 5781],
      [-20, 22],
      [-117, -106],
      [-59, -30],
      [-65, 20],
      [-31, -70],
      [-2, -145],
      [-40, -16],
      [40, -93],
      [2, -51],
      [83, -119],
      [25, -97],
      [-9, -197],
      [-49, -41],
      [47, -133],
      [50, -55],
      [26, -63],
      [2, -132],
      [28, -68],
      [30, -138],
      [-48, -110],
      [-60, -90],
      [-3, -60],
    ],
    [
      [34908, 4009],
      [-36, 65],
      [32, 37],
      [1, 185],
      [-21, 56],
      [17, 76],
      [-37, 148],
      [-36, 28],
      [0, 77],
      [-39, 133],
      [-15, 294],
      [-52, 29],
      [-24, 99],
      [-56, -131],
      [-108, -66],
      [-45, -76],
      [-68, 12],
      [-80, 66],
      [20, 130],
      [25, 75],
      [-12, 140],
      [-43, 133],
      [-58, 33],
      [39, 63],
      [-76, 125],
      [-76, 20],
      [-49, 89],
      [-14, 64],
    ],
    [
      [33540, 10910],
      [44, 50],
      [88, -2],
      [101, 49],
      [-7, 34],
      [224, 100],
      [42, 39],
      [312, -21],
      [48, -98],
      [107, -22],
      [49, 22],
      [138, -23],
      [41, -28],
      [101, 60],
      [24, 81],
      [-61, 86],
      [30, 82],
      [100, 102],
      [208, -55],
      [110, -50],
      [83, -11],
      [35, -149],
      [159, -74],
      [217, 61],
      [166, -26],
      [71, -59],
      [90, -11],
      [11, -61],
      [64, -47],
      [93, 2],
      [112, -31],
      [99, 8],
      [46, 28],
      [214, 39],
      [21, 42],
      [134, 81],
      [59, -7],
      [77, -61],
      [106, 21],
      [59, -34],
    ],
    [
      [37282, 2909],
      [26, -2],
    ],
    [
      [35325, 3281],
      [131, -156],
      [41, -104],
      [6, -82],
      [-20, -102],
      [18, -44],
      [-6, -98],
      [65, -111],
      [43, -159],
      [-116, 17],
      [-148, 120],
      [-113, 124],
      [2, 65],
      [-72, 105],
      [-20, 80],
      [2, 95],
      [-19, 80],
      [-10, 126],
      [-28, 77],
    ],
    [
      [35081, 3314],
      [28, 17],
      [92, -52],
      [3, -108],
      [54, 47],
      [33, -29],
      [34, 92],
    ],
    [
      [36273, 2539],
      [37, -70],
      [58, 1],
      [71, -34],
      [50, 148],
      [9, 61],
      [192, 82],
      [58, 109],
      [64, 92],
      [6, 58],
    ],
    [
      [36942, 3038],
      [6, -13],
    ],
    [
      [36962, 3041],
      [27, 73],
      [61, 43],
      [44, 117],
      [38, 49],
      [21, 68],
      [122, -63],
      [14, -110],
      [82, -19],
      [70, -66],
      [23, -57],
      [-59, -29],
      [-41, 17],
      [-14, -56],
      [38, -65],
      [-123, -35],
    ],
    [
      [29191, 5127],
      [-45, 117],
      [-95, 302],
    ],
    [
      [29051, 5546],
      [376, 178],
      [83, 352],
      [-57, 129],
    ],
    [
      [29603, 6610],
      [29, -86],
      [67, -97],
      [205, -78],
      [37, -81],
      [89, -153],
      [-57, -135],
      [-52, -52],
      [-51, -130],
      [-82, -27],
      [-20, -90],
      [1, -144],
      [-63, -6],
      [-68, -56],
      [-13, -80],
      [-46, -34],
      [-93, -20],
      [-53, -148],
      [-118, 0],
      [-63, -46],
      [-61, -20],
    ],
    [
      [29565, 6802],
      [25, -77],
    ],
    [
      [31081, 6408],
      [-69, -7],
      [-42, 68],
      [-15, 101],
      [-62, 13],
      [4, 72],
      [-37, 44],
      [-128, -16],
      [-92, -29],
      [-137, 24],
      [-9, -30],
      [-128, 11],
      [-50, -28],
      [-61, 18],
    ],
    [
      [38277, 3877],
      [25, -13],
      [59, -103],
      [18, -129],
      [-7, -71],
      [26, -102],
      [-67, -74],
      [-34, 90],
      [-52, -103],
      [40, -110],
      [-40, -103],
      [-26, 40],
      [-117, 69],
      [-24, 45],
      [-10, 94],
      [31, 71],
      [-65, 79],
      [-89, -61],
      [-23, 49],
      [-46, -24],
      [-36, -121],
      [-27, 9],
      [24, 149],
      [20, 34],
      [79, 25],
      [20, 66],
      [85, 16],
      [14, -90],
      [45, 20],
      [22, 70],
      [43, -19],
      [4, 79],
      [92, 12],
      [16, 106],
    ],
    [
      [38115, 3973],
      [30, -22],
      [-23, -65],
      [-43, -12],
      [-32, 37],
      [68, 62],
    ],
    [
      [37979, 4120],
      [39, -27],
      [-53, -170],
      [10, -135],
      [-79, 57],
      [-26, 72],
      [60, 55],
      [-6, 69],
      [18, 61],
      [37, 18],
    ],
    [
      [38071, 4138],
      [-3, -134],
      [-34, 24],
      [37, 110],
    ],
    [
      [37510, 4185],
      [0, -90],
      [24, -61],
      [-65, -78],
      [-56, -30],
      [-31, -102],
      [-47, 5],
      [87, 152],
      [58, 56],
      [-7, 61],
      [37, 87],
    ],
    [
      [38126, 4204],
      [68, -12],
      [3, -104],
      [19, -92],
      [-53, 21],
      [5, 75],
      [-48, 44],
      [6, 68],
    ],
    [
      [37858, 4260],
      [40, -45],
      [70, -8],
      [-20, -67],
      [-54, -69],
      [-45, -10],
      [-23, 66],
      [8, 114],
      [24, 19],
    ],
    [
      [38186, 4402],
      [31, 3],
      [42, -59],
      [-4, -115],
      [13, -80],
      [-45, -3],
      [-27, 87],
      [-76, 106],
      [-14, 56],
      [80, 5],
    ],
    [
      [37693, 4573],
      [56, -53],
      [15, -104],
      [-52, -71],
      [-82, 188],
      [63, 40],
    ],
    [
      [37684, 5470],
      [25, 13],
      [134, -93],
      [-3, -89],
      [47, -94],
      [-41, -147],
      [-78, -59],
      [7, -37],
      [-32, -74],
      [27, -80],
      [17, -119],
      [63, -50],
      [37, 79],
      [40, -13],
      [29, -52],
      [50, -6],
      [36, -129],
      [-41, -34],
      [-34, 74],
      [-79, 91],
      [-5, -106],
      [-97, 107],
      [-56, -66],
      [-86, 107],
      [48, 54],
      [-18, 46],
      [-93, 6],
      [-26, 199],
      [3, 60],
      [62, -15],
      [-15, 79],
      [19, 62],
      [-12, 106],
      [35, 175],
      [37, 5],
    ],
    [
      [38889, 9730],
      [21, -41],
    ],
    [
      [38910, 9689],
      [-79, -39],
      [-47, -76],
      [7, -132],
      [-68, -41],
      [-113, -115],
      [-98, -50],
      [-18, -67],
      [123, -124],
    ],
    [
      [38399, 8887],
      [-70, 3],
      [-33, 34],
      [-52, -50],
      [-46, 34],
      [-16, 80],
      [68, 168],
      [-26, 52],
      [-72, 14],
      [-35, 76],
    ],
    [
      [28956, 6547],
      [-51, 21],
    ],
    [
      [28905, 6568],
      [-7, 120],
      [34, 108],
      [28, 24],
      [43, -69],
      [3, -98],
      [-22, -97],
      [-28, -9],
    ],
    [
      [40431, 11820],
      [6, -83],
      [50, -118],
      [-9, -288],
      [30, -11],
      [41, -206],
      [62, -189],
      [-98, 18],
      [-41, -18],
      [-78, -218],
      [-1, -46],
      [59, -91],
      [20, -97],
      [-90, -14],
      [-32, -106],
      [-33, 1],
      [-14, 100],
      [29, 81],
      [-11, 99],
      [28, 63],
      [-28, 159],
      [24, 145],
      [-14, 152],
      [28, 97],
      [-79, 144],
      [3, 88],
      [33, 114],
      [-15, 56],
      [124, 64],
      [-49, 95],
      [55, 9],
    ],
    [
      [36, 14422],
      [127, -66],
      [248, -92],
      [52, -54],
      [127, -10],
      [75, -161],
      [143, 58],
      [111, -36],
      [96, 15],
      [167, -110],
      [108, -40],
      [-121, -94],
      [-187, -32],
      [8, -65],
      [-76, -31],
      [-51, -113],
      [-110, 30],
      [-83, 56],
      [-141, 38],
      [-17, 82],
      [-133, 37],
      [-164, -29],
      [-88, 127],
      [-98, -10],
      [62, -84],
      [-91, -101],
      [0, 0],
      [0, 1],
      [0, 89],
      [0, 88],
      [0, 89],
      [0, 89],
      [0, 88],
      [0, 89],
      [0, 89],
      [0, 75],
      [0, 0],
      [36, -12],
    ],
    [
      [43758, 14574],
      [-67, -36],
      [-136, 43],
      [59, 38],
      [144, -45],
    ],
    [
      [45084, 14888],
      [0, -86],
      [0, -11],
      [-137, 44],
      [137, 53],
    ],
    [
      [158, 14894],
      [162, -59],
      [-61, -35],
      [-259, -9],
      [0, 0],
      [0, 11],
      [0, 86],
      [0, 0],
      [158, 6],
    ],
    [
      [31427, 15240],
      [68, -65],
      [-202, -20],
      [13, 66],
      [121, 19],
    ],
    [
      [40359, 15302],
      [142, -57],
      [-29, -65],
      [-336, 54],
      [80, 71],
      [143, -3],
    ],
    [
      [36739, 15388],
      [-74, -46],
      [-149, 30],
      [66, 52],
      [157, -36],
    ],
    [
      [40917, 15591],
      [211, -12],
      [278, -55],
      [-3, -39],
      [-305, -16],
      [-263, 77],
      [82, 45],
    ],
    [
      [39963, 15699],
      [130, -53],
      [195, 57],
      [106, -46],
      [175, -5],
      [105, -69],
      [-57, -71],
      [-247, -39],
      [-64, 31],
      [-314, -56],
      [-147, 16],
      [-127, 64],
      [35, 145],
      [210, 26],
    ],
    [
      [29137, 11319],
      [24, 35],
      [275, 19],
      [218, -63],
      [97, -13],
      [125, 51],
      [44, 157],
      [44, 328],
      [5, 176],
      [-45, 403],
      [-13, 315],
      [0, 347],
      [31, 151],
      [5, 151],
      [71, 265],
      [208, 170],
      [111, 19],
      [426, 289],
      [49, 76],
      [40, 157],
      [88, 46],
      [166, -98],
      [91, 115],
      [-78, 17],
      [-65, 92],
      [-150, 45],
      [68, 185],
      [-88, 17],
      [39, 75],
      [195, 95],
      [100, 179],
      [286, 13],
      [117, -23],
      [46, -91],
      [-128, -132],
      [123, -114],
      [-46, -104],
      [16, -244],
      [133, -77],
      [-70, -51],
      [15, -62],
      [-100, -68],
      [-104, -146],
      [-152, -58],
      [204, -18],
      [63, 69],
      [125, 36],
      [51, 84],
      [104, 69],
      [-35, 180],
      [241, 53],
      [118, -83],
      [45, 64],
      [-272, 66],
      [-92, -32],
      [-128, 19],
      [-29, 100],
      [100, 137],
      [-95, 131],
      [-65, 33],
      [61, 68],
      [428, 39],
      [195, 65],
      [111, -4],
      [294, -122],
      [204, 25],
      [-333, 125],
      [17, 67],
      [-61, 82],
      [60, 34],
      [332, 15],
      [460, 44],
      [-142, 64],
      [167, 139],
      [222, 72],
      [554, 71],
      [17, 50],
      [213, 6],
      [86, -36],
      [221, 5],
      [209, 85],
      [191, 9],
      [-15, 81],
      [156, 76],
      [233, 59],
      [246, -53],
      [158, -76],
      [43, -90],
      [218, 45],
      [278, -13],
      [214, -74],
      [79, -73],
      [-36, -102],
      [-233, -110],
      [-218, -52],
      [-189, -107],
      [-170, -43],
      [73, -64],
      [250, 51],
      [38, 99],
      [224, -48],
      [832, -27],
      [-12, -55],
      [273, -72],
      [260, 28],
      [118, 33],
      [-38, 58],
      [136, 46],
      [257, -70],
      [99, 23],
      [215, -57],
      [-117, -99],
      [29, -77],
      [150, -157],
      [114, -72],
      [164, 0],
      [82, 132],
      [279, -55],
      [141, 44],
      [218, -44],
      [175, 48],
      [140, 95],
      [-42, 57],
      [168, 7],
      [84, 42],
      [483, -39],
      [190, -43],
      [185, 0],
      [151, -29],
      [20, -89],
      [232, -63],
      [124, -82],
      [416, 47],
      [258, -9],
      [212, -67],
      [53, -72],
      [-53, -67],
      [155, -44],
      [389, 23],
      [101, -36],
      [263, -12],
      [92, 48],
      [88, -98],
      [248, -70],
      [84, 41],
      [-55, 97],
      [3, 91],
      [173, -22],
      [565, -42],
      [284, -60],
      [154, -77],
      [0, -75],
      [0, -89],
      [0, -89],
      [0, -88],
      [0, -89],
      [0, -89],
      [0, -88],
      [0, -89],
      [0, -1],
      [-156, -75],
      [-182, 35],
      [-72, -46],
      [210, -60],
      [45, -107],
      [72, -79],
      [34, -87],
      [-57, -65],
      [-137, 35],
      [-183, -8],
      [-264, -121],
      [-124, -43],
      [-187, -127],
      [-179, -75],
      [-22, -83],
      [-155, 107],
      [-134, 0],
      [-131, -43],
      [-95, -86],
      [-4, 114],
      [-127, -68],
      [-29, -45],
      [-170, 36],
      [-208, -349],
      [167, -68],
      [-62, -58],
      [-6, -110],
      [62, -13],
      [11, -90],
      [-68, -23],
      [-85, 13],
      [-46, -92],
      [12, -94],
      [35, -41],
      [-50, -59],
      [-127, 3],
      [-86, -64],
      [-26, -67],
      [10, -92],
      [-115, -36],
      [-62, -59],
      [4, -80],
      [-98, -134],
      [-130, -117],
      [-24, 72],
      [-20, 198],
      [-33, 95],
      [-70, 417],
      [17, 134],
      [55, 141],
      [74, 45],
      [27, 102],
      [141, 59],
      [121, 76],
      [105, 129],
      [118, 82],
      [142, 145],
      [176, 68],
      [86, 97],
      [12, 163],
      [59, 73],
      [-167, -27],
      [-36, -127],
      [-70, -23],
      [-199, -164],
      [-104, 62],
      [-4, 49],
      [-76, 91],
      [-237, -19],
      [-98, -46],
      [-8, -45],
      [-88, -92],
      [-121, -69],
      [-91, -89],
      [26, -57],
      [-48, -88],
      [-85, 34],
      [-57, -58],
      [-64, 19],
      [-131, -30],
      [-18, 42],
      [53, 70],
      [-255, 49],
      [-59, -21],
      [-43, -72],
      [-109, 27],
      [-60, -23],
      [-125, 36],
      [-180, -16],
      [-231, -3],
      [-112, -41],
      [-85, -90],
      [-85, -42],
      [-51, -96],
      [-230, -154],
      [-136, -153],
      [-214, -168],
      [-81, -49],
      [66, -58],
      [142, 4],
      [72, -49],
      [18, -87],
      [40, -43],
      [73, -7],
      [83, 117],
      [82, 2],
      [202, -190],
      [-30, -28],
      [-3, -111],
      [32, -78],
      [-65, -55],
      [-58, -191],
      [2, -199],
      [-37, -173],
      [-97, -97],
      [-54, -105],
      [-53, -58],
      [-54, -135],
      [-54, -77],
      [-106, -105],
      [-88, -130],
      [-29, -13],
      [-94, -159],
      [-163, -108],
      [-85, -37],
      [-95, 45],
      [-80, 62],
      [-36, -75],
      [-79, -56],
      [-18, -46],
    ],
    [
      [35432, 16264],
      [283, -84],
      [21, -53],
      [-206, -44],
      [-313, -11],
      [-145, 26],
      [122, 139],
      [238, 27],
    ],
    [
      [33926, 16406],
      [353, -26],
      [-137, -45],
      [-216, 71],
    ],
    [
      [34787, 16416],
      [281, -55],
      [-77, -178],
      [-206, -2],
      [-344, 41],
      [-159, 90],
      [149, 93],
      [356, 11],
    ],
    [
      [34560, 16607],
      [126, -53],
      [27, -120],
      [-437, -42],
      [-149, 29],
      [68, 149],
      [365, 37],
    ],
    [
      [28607, 7243],
      [22, -74],
      [79, -103],
      [21, -73],
      [67, -49],
      [35, -115],
      [-15, -40],
      [89, -221],
    ],
    [
      [28956, 6547],
      [44, -66],
    ],
    [
      [29051, 5546],
      [-356, -68],
      [-122, -83],
      [-71, -122],
      [-21, -66],
      [-57, -24],
      [-32, 57],
      [-49, -9],
      [-112, 15],
      [-33, 21],
      [-177, -15],
      [-45, 30],
      [-28, -33],
      [5, -98],
      [-52, -72],
    ],
    [
      [27901, 5079],
      [-7, 53],
      [-50, 90],
      [-4, 50],
      [-73, 81],
      [-64, 140],
      [-32, 115],
      [-54, 112],
      [-110, 86],
      [-71, 152],
      [-13, 97],
      [21, 94],
      [-22, 86],
      [-64, 162],
      [-125, 117],
      [-39, 73],
      [10, 61],
      [-71, 118],
      [-54, 136],
      [-147, 266],
      [-54, 7],
      [41, 212],
    ],
    [
      [27034, 8113],
      [-12, -122],
    ],
    [
      [27047, 8329],
      [-1, 98],
      [-29, 64],
      [22, 64],
    ],
    [
      [27039, 8555],
      [29, -18],
      [56, 90],
      [9, 89],
      [73, -30],
    ],
    [
      [27206, 8686],
      [26, -4],
    ],
    [
      [27232, 8682],
      [93, 48],
      [59, -33],
      [138, 4],
      [142, 68],
      [183, -2],
    ],
    [
      [35430, 4239],
      [-20, 70],
      [-57, 27],
      [-64, 91],
      [-119, 1],
      [14, 135],
      [-82, 7],
      [-42, -149],
      [8, -85],
      [-66, -192],
      [2, -37],
      [-45, -97],
      [4, -127],
      [37, -79],
      [47, 17],
      [13, -117],
      [33, -34],
      [26, -227],
      [71, -56],
      [72, -4],
      [63, -102],
    ],
    [
      [35081, 3314],
      [-104, 209],
      [-87, 134],
      [-50, 29],
      [16, 119],
      [52, 204],
    ],
    [
      [31030, 8781],
      [6, 60],
      [67, 115],
      [-38, 64],
      [6, 79],
      [-91, 39],
      [48, 75],
      [95, -13],
      [10, 112],
      [86, 7],
      [-11, 59],
      [135, 59],
      [10, -75],
      [75, -39],
    ],
    [
      [29294, 8808],
      [-11, 210],
      [18, 73],
      [-42, 36],
      [-25, 154],
      [-69, -10],
      [-19, 96],
      [47, 51],
      [77, -26],
      [115, 38],
      [-5, 63],
      [-70, 60],
      [-18, 97],
      [-97, 2],
      [-86, -61],
    ],
    [
      [29552, 9516],
      [130, -12],
      [-8, 108],
      [54, 53],
      [59, 5],
      [18, 54],
      [77, 51],
      [109, -88],
      [48, 3],
      [69, -190],
      [113, -11],
      [82, -28],
      [48, -104],
      [12, -75],
      [209, -186],
      [27, 2],
      [159, -131],
      [34, 6],
      [94, -49],
      [-14, -112],
    ],
    [
      [38075, 507],
      [52, 29],
    ],
    [
      [38186, 575],
      [26, 56],
      [231, 60],
      [5, -66],
      [-73, -49],
      [-103, -41],
      [-68, -53],
    ],
    [
      [25965, 9646],
      [59, -11],
      [73, -97],
      [90, -38],
      [-39, -48],
      [-70, 21],
      [-89, -17],
      [-43, -63],
      [-138, -4],
      [70, 137],
      [-38, 59],
      [36, 46],
      [89, 15],
    ],
    [
      [27232, 8682],
      [-26, 4],
    ],
    [
      [27039, 8555],
      [-15, 71],
      [50, 51],
      [-25, 55],
      [-80, -66],
      [-73, 48],
      [-153, -119],
      [-110, -17],
      [-80, 88],
      [-86, 47],
      [-82, 15],
      [-31, -116],
      [-81, -17],
      [-59, 18],
      [-28, 75],
      [-193, 82],
      [-44, 48],
      [4, 105],
      [-79, 21],
      [42, 58],
      [9, 78],
      [-38, 83],
      [-70, 21],
      [0, 86],
      [73, 82],
      [90, -14],
      [148, 7],
      [79, 90],
      [-4, 66],
      [252, -24],
      [22, 39],
      [105, 70],
      [133, 54],
      [126, -13],
      [70, 11],
      [51, -53],
      [75, -1],
      [202, -118],
      [103, -22],
      [138, 34],
      [87, -34],
      [161, 84],
      [14, 22],
    ],
    [
      [37775, 6653],
      [32, -19],
      [-5, -100],
      [-24, -64],
      [-33, -186],
      [-56, -110],
      [-41, -42],
      [-37, 40],
      [-34, 113],
      [17, 111],
      [109, 226],
      [72, 31],
    ],
    [
      [36066, 5989],
      [-75, -37],
      [-7, -49],
      [-49, -9],
      [-40, -60],
      [-7, -68],
      [-68, -42],
      [-27, -71],
      [-23, -120],
      [59, -113],
      [38, -32],
      [29, -113],
      [73, -100],
      [131, -149],
      [45, -97],
      [41, -49],
      [44, -265],
      [-8, -53],
      [29, -98],
      [-33, -47],
      [5, -162],
      [-28, -68],
      [-85, -71],
      [-127, -91],
      [-68, -9],
      [-26, -132],
      [-48, -50],
      [-82, -42],
      [-55, -89],
      [-41, 33],
      [15, 184],
      [24, 26],
      [-79, 75],
    ],
    [
      [26677, 8326],
      [-32, 4],
    ],
    [
      [29191, 5127],
      [-62, -29],
      [-55, -88],
      [9, -65],
      [-108, -69],
      [-102, -32],
      [-47, -37],
      [-75, -18],
      [-63, -41],
      [-49, -83],
      [-84, 3],
      [-77, -72],
      [-90, -40],
      [-127, -15],
      [-100, -109],
      [-41, 12],
      [-44, -32],
      [-90, 40],
      [-28, 66],
      [4, 90],
      [-23, 64],
      [-20, 154],
      [-30, 137],
      [12, 116],
    ],
    [
      [29251, 4427],
      [69, 0],
      [2, -63],
      [-71, -3],
      [0, 66],
    ],
  ],
  transform: {
    scale: [0.007985094490284802, 0.005624101760523118],
    translate: [-180, -12.194533921845045],
  },
  objects: {
    continent_Asia_subunits: {
      type: "GeometryCollection",
      geometries: [
        {
          arcs: [[0, 1, 2, 3, 4, 5]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Afghanistan" },
        },
        {
          arcs: [[6, 7, 8, 9, 10]],
          type: "Polygon",
          properties: {
            type: "Sovereign country",
            geounit: "United Arab Emirates",
          },
        },
        {
          arcs: [[11, 12, 13, 14, 15]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Armenia" },
        },
        {
          arcs: [[[16, 17, -14]], [[18, 19, -12, 20]]],
          type: "MultiPolygon",
          properties: { type: "Sovereign country", geounit: "Azerbaijan" },
        },
        {
          arcs: [[21, 22, 23]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Bangladesh" },
        },
        {
          type: null,
          properties: { type: "Sovereign country", geounit: "Bahrain" },
        },
        {
          arcs: [[26, 27]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Brunei" },
        },
        {
          arcs: [[28, 29]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Bhutan" },
        },
        {
          type: null,
          properties: { type: "Geo unit", geounit: "Cocos (Keeling) Islands" },
        },
        {
          arcs: [[30]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "China" },
        },
        {
          arcs: [
            [
              31, 32, 33, 34, 35, 36, 37, 38, -30, 39, 40, 41, 42, 43, -1, 44,
              45, 46, 47, 48, 49,
            ],
          ],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "China" },
        },
        {
          arcs: [[[50, 51, 52, 53]], [[54, 55, 56, 57]], [[58, 59, 60, 61]]],
          type: "MultiPolygon",
          properties: { type: "Indeterminate", geounit: "Cyprus No Mans Area" },
        },
        {
          type: null,
          properties: { type: "Geo unit", geounit: "Christmas Island" },
        },
        {
          arcs: [[-54, 63, -62, 64]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Northern Cyprus" },
        },
        {
          arcs: [[[65, 66, -52]], [[67, 68, 69, 70, -58, 71, -60]]],
          type: "MultiPolygon",
          properties: { type: "Sovereign country", geounit: "Cyprus" },
        },
        {
          arcs: [[-53, -67, 72, 73, -68, -59, -64]],
          type: "Polygon",
          properties: {
            type: "Dependency",
            geounit: "Dhekelia Sovereign Base Area",
          },
        },
        {
          arcs: [[74, 75]],
          type: "Polygon",
          properties: { type: "Geo unit", geounit: "Gaza" },
        },
        {
          arcs: [[76, 77, 78]],
          type: "Polygon",
          properties: { type: "Geo unit", geounit: "Ajaria" },
        },
        {
          arcs: [[-21, -16, 79, -79, 80]],
          type: "Polygon",
          properties: { type: "Geo unit", geounit: "Georgia" },
        },
        {
          arcs: [[81, -34]],
          type: "Polygon",
          properties: { type: "Country", geounit: "Hong Kong S.A.R." },
        },
        {
          arcs: [
            [[82]],
            [[83, 84, 85, 86]],
            [[87]],
            [[88]],
            [[89]],
            [[90]],
            [[91]],
            [[92]],
            [[93]],
            [[94]],
            [[95]],
            [[96]],
            [[97]],
            [[98]],
            [[99]],
            [[100]],
            [[101]],
            [[102]],
            [[103]],
            [[104]],
            [[105]],
            [[106]],
            [[107]],
            [[108]],
            [[111, 112]],
            [[113]],
          ],
          type: "MultiPolygon",
          properties: { type: "Sovereign country", geounit: "Indonesia" },
        },
        {
          arcs: [[114, -40, -29, -39, 115, -24, 116, 117, 118, -42]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "India" },
        },
        {
          arcs: [[119, 120, 121, 122]],
          type: "Polygon",
          properties: { type: "Geo unit", geounit: "Iraqi Kurdistan" },
        },
        {
          arcs: [[-13, -20, 123, 124, -3, 125, 126, 127, -120, 128, -17]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Iran" },
        },
        {
          arcs: [[-128, 129, 130, 131, 132, 133, -121]],
          type: "Polygon",
          properties: { type: "Geo unit", geounit: "Iraq" },
        },
        {
          arcs: [[134, 135, 136, 137, -76, 138, 139, 140]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Israel" },
        },
        {
          arcs: [[141, 142, -137, 143, -135, 144, 145, -133]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Jordan" },
        },
        { type: null, properties: { type: "Geo subunit", geounit: "Japan" } },
        {
          arcs: [[146]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Japan" },
        },
        { type: null, properties: { type: "Geo subunit", geounit: "Japan" } },
        {
          arcs: [[147]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Japan" },
        },
        { type: null, properties: { type: "Geo subunit", geounit: "Japan" } },
        {
          arcs: [[148]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Japan" },
        },
        { type: null, properties: { type: "Geo subunit", geounit: "Japan" } },
        { type: null, properties: { type: "Geo subunit", geounit: "Japan" } },
        {
          arcs: [[149]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Japan" },
        },
        {
          arcs: [[150]],
          type: "Polygon",
          properties: { type: "Lease", geounit: "Baykonur Cosmodrome" },
        },
        {
          arcs: [[-119, 151, -43]],
          type: "Polygon",
          properties: { type: "Indeterminate", geounit: "Siachen Glacier" },
        },
        {
          arcs: [[-47, 152, 153, 154, 155, 156], [-151]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Kazakhstan" },
        },
        {
          arcs: [[-46, 157, 158, -153]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Kyrgyzstan" },
        },
        {
          arcs: [[159, 160, 161, 162]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Cambodia" },
        },
        {
          arcs: [[163, 164, 165, 166]],
          type: "Polygon",
          properties: {
            type: "Overlay",
            geounit: "Korean Demilitarized Zone (south)",
          },
        },
        {
          arcs: [[-166, 167, 168, 169]],
          type: "Polygon",
          properties: {
            type: "Overlay",
            geounit: "Korean Demilitarized Zone (north)",
          },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "South Korea" },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "South Korea" },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "South Korea" },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "South Korea" },
        },
        {
          arcs: [[-164, 170]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "South Korea" },
        },
        {
          arcs: [[171, -131, 172]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Kuwait" },
        },
        {
          type: null,
          properties: { type: "Geo subunit", geounit: "South Korea" },
        },
        {
          arcs: [[173, -162, 174, 175, -37]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Laos" },
        },
        {
          arcs: [[176, -140, 177, 178]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Lebanon" },
        },
        {
          arcs: [[179]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Sri Lanka" },
        },
        { type: null, properties: { type: "Country", geounit: "Macao S.A.R" } },
        {
          arcs: [[-176, 180, 181, -22, -116, -38]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Myanmar" },
        },
        {
          arcs: [[-49, 182]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Mongolia" },
        },
        {
          arcs: [[[184, 185]], [[-113, 186, -28, 187, -25, 188]]],
          type: "MultiPolygon",
          properties: { type: "Sovereign country", geounit: "Malaysia" },
        },
        {
          arcs: [[-115, -41]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Nepal" },
        },
        {
          arcs: [[189, 190, -8, 191]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Oman" },
        },
        {
          arcs: [[-152, -118, 193, -126, -2, -44]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Pakistan" },
        },
        {
          type: null,
          properties: { type: "Geo unit", geounit: "Paracel Islands" },
        },
        {
          type: null,
          properties: { type: "Indeterminate", geounit: "Spratly Islands" },
        },
        {
          arcs: [
            [[194]],
            [[195]],
            [[196]],
            [[197]],
            [[198]],
            [[199]],
            [[200]],
            [[201]],
            [[202]],
            [[203]],
          ],
          type: "MultiPolygon",
          properties: { type: "Sovereign country", geounit: "Philippines" },
        },
        {
          arcs: [[204, 205, -169, 206, -32]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "North Korea" },
        },
        {
          arcs: [[207, 208]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Qatar" },
        },
        {
          arcs: [
            [[209]],
            [[210]],
            [[211]],
            [[212]],
            [[213]],
            [[214]],
            [[215]],
            [[216]],
            [[217]],
            [[218]],
            [[-205, -50, -183, -48, -157, 219]],
            [[220]],
            [[221]],
            [[222]],
            [[223]],
          ],
          type: "MultiPolygon",
          properties: { type: "Geo subunit", geounit: "Russia" },
        },
        {
          arcs: [[-172, 224, -208, 225, -9, -191, 226, 227, -142, -132]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Saudi Arabia" },
        },
        {
          type: null,
          properties: { type: "Indeterminate", geounit: "Scarborough Reef" },
        },
        {
          type: null,
          properties: { type: "Sovereign country", geounit: "Singapore" },
        },
        {
          arcs: [[-145, -141, -177, 228]],
          type: "Polygon",
          properties: { type: "Overlay", geounit: "UNDOF" },
        },
        {
          arcs: [[-122, -134, -146, -229, -179, 229, 230, 231, 232]],
          type: "Polygon",
          properties: { type: "Geo unit", geounit: "Syria" },
        },
        {
          arcs: [[-175, -161, 233, -186, 234, -181]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Thailand" },
        },
        {
          arcs: [[-158, -45, -6, 235]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Tajikistan" },
        },
        {
          arcs: [[-4, -125, 236, -155, 237]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Turkmenistan" },
        },
        {
          arcs: [[238, -85]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "East Timor" },
        },
        {
          arcs: [[-87, 239]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "East Timor" },
        },
        {
          arcs: [
            [[240]],
            [[-77, -80, -15, -18, -129, -123, -233, 241, -231, 242]],
          ],
          type: "MultiPolygon",
          properties: { type: "Sovereign country", geounit: "Turkey" },
        },
        {
          arcs: [[243]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Taiwan" },
        },
        {
          arcs: [[-159, -236, -5, -238, -154]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Uzbekistan" },
        },
        {
          arcs: [[244, -163, -174, -36]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Vietnam" },
        },
        {
          arcs: [[-144, -136]],
          type: "Polygon",
          properties: { type: "Geo unit", geounit: "West Bank" },
        },
        {
          arcs: [[245, -70]],
          type: "Polygon",
          properties: {
            type: "Dependency",
            geounit: "Akrotiri Sovereign Base Area",
          },
        },
        {
          arcs: [[246, -227, -190]],
          type: "Polygon",
          properties: { type: "Sovereign country", geounit: "Yemen" },
        },
        {
          arcs: [[247]],
          type: "Polygon",
          properties: { type: "Geo subunit", geounit: "Yemen" },
        },
      ],
    },
  },
};
